import { Button, Input } from "@shared/ui";
import { Banknote, Download, Search } from "lucide-react";
import styles from "./styles.module.scss";

type PayoutsPageHeaderProps = {
  matchingCount: number;
  searchQuery: string;
  onSearchChange: (value: string) => void;
  showPay: boolean;
  selectedCount: number;
  onPay: () => void;
  isDownloading?: boolean;
  onDownload?: () => void;
};

export function PayoutsPageHeader({
  matchingCount,
  searchQuery,
  onSearchChange,
  showPay,
  selectedCount,
  onPay,
  isDownloading,
  onDownload,
}: PayoutsPageHeaderProps) {
  return (
    <div className={styles.header}>
      <div className={styles.identity}>
        <div className={styles.iconWrap}>
          <Banknote size={18} />
        </div>
        <div>
          <h2 className={styles.title}>All payouts</h2>
          <p className={styles.meta}>{matchingCount} matching</p>
        </div>
      </div>
      <div className={styles.actions}>
        <Input
          placeholder="Search by name, handle, UTR, campaign, email, token…"
          value={searchQuery}
          onChange={(event) => onSearchChange(event.target.value)}
          allowClear
          className={styles.searchInput}
          prefix={<Search size={14} />}
        />
        {onDownload ? (
          <Button
            icon={<Download size={14} />}
            loading={isDownloading}
            onClick={onDownload}
          >
            Download
          </Button>
        ) : null}
        {showPay ? (
          <Button
            type="primary"
            disabled={selectedCount === 0}
            onClick={onPay}
          >
            Pay ({selectedCount})
          </Button>
        ) : null}
      </div>
    </div>
  );
}
